import React from 'react';
import { render } from 'react-dom';
import Spinner from 'ui-connect/Spinner/Spinner';

const AccountSharingIndex = () => {
    // have to inject the global style due to the privacy-overlay,
    // we are don't need it on loading screen
    const LandingPage = () => {
        return (
            <div
                style={{
                    display: 'grid',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: '100vh',
                    width: '100vw',
                    alignContent: 'center',
                    justifyContent: 'center'
                }}
            >
                <style>
                    {`.privacy-overlay {
                            display: none;
                        }`}
                </style>
                <Spinner size="default" />
            </div>
        );
    };
    render(<LandingPage />, document.querySelector('.content'));
};

export default AccountSharingIndex;
